<div class="auth-layout">
  <!-- Mobile: Condensed branding header -->
  <div class="auth-layout__mobile-header">
    <img
      src="/assets/logos/cyflare-one-logo-white-gradient.png"
      alt="Cyflare One"
      class="mobile-logo"
    />
  </div>

  <!-- Desktop: Full branding panel -->
  <div class="auth-layout__branding">
    <app-auth-branding />
  </div>

  <!-- Form area -->
  <div class="auth-layout__form">
    <router-outlet />
  </div>
</div>
